export const routes = [
  {
    path: '/sala-principal/:id/sala-indicadores-unidade',
    component: () => import(/* webpackChunkName: "ur" */ './components/List'),
    name: 'sala.unidade.list',
    meta: {
      requiresAuth: true
    }
  }
]
